/**
 * Project-inquiry modal.
 * Opens from any [href="#project-modal"] or .open-project-modal element.
 * Handles: overlay/Esc/close, conditional contact field, CF7 success screen.
 */
export default function projectModal() {
  const modal = document.getElementById('project-modal');
  if (!modal) return;

  const dialog = modal.querySelector('.project-modal__dialog');
  const formWrap = modal.querySelector('.project-modal__form');
  const success = modal.querySelector('.project-modal__success');
  let lastFocused = null;

  const open = (e) => {
    if (e) e.preventDefault();
    lastFocused = document.activeElement;
    // always start on the form view
    if (formWrap) formWrap.hidden = false;
    if (success) success.hidden = true;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pm-lock');
    syncConditional();
    const first = modal.querySelector('input, textarea, button');
    if (first) setTimeout(() => first.focus(), 50);
  };

  const close = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pm-lock');
    if (lastFocused) lastFocused.focus();
  };

  // triggers (both: href="#project-modal" and .open-project-modal)
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('a[href="#project-modal"], .open-project-modal');
    if (trigger) open(e);
    if (e.target.closest('[data-pm-close]')) close();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
  });

  /* ── conditional contact field (only the visible one is required) ── */
  function syncConditional() {
    const checked = modal.querySelector('input[name="contact-method"]:checked');
    const method = checked ? checked.value : '';
    modal.querySelectorAll('.pm-conditional').forEach((el) => {
      const show = el.getAttribute('data-method') === method;
      el.style.display = show ? '' : 'none';
      const field = el.querySelector('input');
      if (field) field.required = show;
    });
  }

  modal.addEventListener('change', (e) => {
    if (e.target.name === 'contact-method') syncConditional();
  });

  /* маска телефону/WhatsApp — у спільному модулі formMasks.js (site-wide) */

  /* ── show chosen file name ── */
  modal.addEventListener('change', (e) => {
    if (e.target.type === 'file') {
      const field = e.target.closest('.pm-field--file');
      if (!field) return;
      const name = e.target.files && e.target.files[0] ? e.target.files[0].name : '';
      field.classList.toggle('has-file', !!name);
      const hint = field.querySelector('.pm-file-hint');
      if (hint) hint.textContent = name || 'PNG • JPG • PDF • DOCX · до 10 МБ';
    }
  });

  /* ── CF7 success → swap to the thank-you screen ── */
  document.addEventListener('wpcf7mailsent', (event) => {
    if (!modal.contains(event.target)) return;
    if (formWrap) formWrap.hidden = true;
    if (success) success.hidden = false;
    if (dialog) dialog.scrollTop = 0;
  });
}
